import React, { useState, useEffect } from "react";
import { useSetSuccessorFileAccess } from "hooks/successors";
import { Switch } from "shared";
import "./DocumentSwitch.scss";

interface DocumentSwitchType {
  canViewFiles: boolean;
}

const DocumentSwitch: React.FC<DocumentSwitchType> = ({ canViewFiles }) => {
  const [isActive, setIsActive] = useState<boolean>(Boolean(canViewFiles));
  const { mutate: setFileAccess } = useSetSuccessorFileAccess({
    onSuccess: ({ canViewFiles }) => {
      setIsActive(canViewFiles);
    },
  });

  useEffect(() => {
    setIsActive(Boolean(canViewFiles));
  }, [canViewFiles]);

  const hanlderChange = () => {
    setFileAccess({ canViewFiles: !isActive });
  };

  return (
    <div className="document-switch">
      <Switch state={isActive} onClick={() => hanlderChange()} />
      Wyrażam zgodę na dostęp pracowników firmy Reliance do dokumentów dodanych
      przeze mnie w zakładce Sukcesja.
    </div>
  );
};

export default DocumentSwitch;
